import { render, staticRenderFns } from "./Cilindrada.vue?vue&type=template&id=232b81f3&"
import script from "./Cilindrada.vue?vue&type=script&lang=js&"
export * from "./Cilindrada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports